import { scrollToId } from "../config";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-surface/40 py-14">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 md:flex-row md:items-start md:justify-between">
      <div>
        <div className="flex flex-col leading-none">
          <span className="font-display text-2xl font-extrabold tracking-tight">cardconnect</span>
          <span className="font-mono text-[10px] tracking-[0.45em] text-mint">COMMERCE</span>
        </div>
        <p className="mt-4 max-w-xs text-sm text-white/50">
          Save Money. Get Up to $1,000. Zero Hassle. Switching should be a no-brainer.
        </p>
      </div>
      <nav className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.2em] text-white/50">
        <button data-testid="footer-savings" onClick={() => scrollToId("calculator")} className="text-left transition-colors hover:text-mint">Savings Calculator</button>
        <button data-testid="footer-why" onClick={() => scrollToId("why")} className="text-left transition-colors hover:text-mint">Why Switch</button>
        <button data-testid="footer-solutions" onClick={() => scrollToId("solutions")} className="text-left transition-colors hover:text-mint">Solutions</button>
        <button data-testid="footer-faq" onClick={() => scrollToId("faq")} className="text-left transition-colors hover:text-mint">FAQ</button>
      </nav>
      <div className="max-w-sm text-[11px] leading-relaxed text-white/30">
        Savings figures shown on this site are estimates for illustrative purposes only and are not
        a quote, offer, or guarantee of pricing or savings. Actual rates and savings vary.
        <p className="mt-4 font-mono">© 2026 CardConnect Commerce. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
